// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.liveView-content-title {
    margin: 10px 10px 0;
    font-size: 0.6rem;
    font-weight: 700;
    letter-spacing: 0.12em;
    color: rgba(255, 255, 255, 0.3);
}

.liveView-content-data {
    margin: 0 10px;
    padding: 10px 0;
}

.liveView-content-flex {
    display: flex;
    justify-content: space-between;
}

.liveView-content-data-1-text {
    margin: 3px 0;
}

.liveView-content-country {
    margin-bottom: 5px;
}

.liveView-content-data-2 {
    width: 100%;
}

.liveView-content-data-1-number {
    font-size: 30px;
    font-weight: 200;
    margin-top: 0;
}

/* Domain rows: clear click target, matches dashboard affordance */
.liveView-domain-block {
    margin-bottom: 12px;
}

.liveView-domain-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin: 0;
    padding: 8px 10px;
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 8px;
    background: rgba(0, 0, 0, 0.2);
    cursor: pointer;
    text-align: left;
    font: inherit;
    color: inherit;
    transition: background 0.2s ease, border-color 0.2s ease;
}

.liveView-domain-row:hover {
    background: rgba(192, 159, 83, 0.12);
    border-color: rgba(192, 159, 83, 0.35);
}

.liveView-domain-row:focus-visible {
    outline: 2px solid rgba(192, 159, 83, 0.8);
    outline-offset: 2px;
}

.liveView-domain-row__name {
    word-break: break-all;
    padding-right: 12px;
}

.liveView-domain-row__count {
    flex-shrink: 0;
    font-variant-numeric: tabular-nums;
}

.liveView-domain-bar-track {
    width: 100%;
    height: 3px;
    margin-top: 6px;
    border-radius: 999px;
    background: rgba(196, 196, 196, 0.35);
    overflow: hidden;
}

.liveView-domain-bar-fill {
    height: 100%;
    border-radius: 999px;
    background: linear-gradient(90deg, rgba(192, 159, 83, 0.5), rgb(222, 189, 113));
    transition: width 0.35s ease;
}

/* Drawer extras (reuses .world-map-drawer from WorldMap/Style.css) */
.live-view-drawer__subtitle {
    margin: 8px 0 0;
    font-size: 0.78rem;
    line-height: 1.4;
    color: rgba(255, 255, 255, 0.45);
    font-weight: 400;
}

.live-view-drawer__summary-label {
    display: block;
    font-size: 0.62rem;
    font-weight: 600;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: rgba(255, 255, 255, 0.38);
    margin-bottom: 12px;
}

.live-view-drawer__visit-patterns {
    flex-shrink: 0;
    padding: 14px 18px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}

.live-view-drawer__visit-row {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
    padding: 10px 0;
    border-top: 1px solid rgba(255, 255, 255, 0.06);
}

.live-view-drawer__visit-patterns .live-view-drawer__visit-row:first-of-type {
    border-top: none;
    padding-top: 0;
}

.live-view-drawer__visit-row-main {
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.live-view-drawer__visit-label {
    font-size: 0.95rem;
    font-weight: 600;
    color: rgb(240, 240, 240);
}

.live-view-drawer__visit-label--accept {
    color: rgba(170, 220, 155, 0.98);
}

.live-view-drawer__visit-label--essential {
    color: rgba(192, 159, 83, 0.95);
}

.live-view-drawer__visit-label--granular {
    color: rgba(150, 195, 215, 0.95);
}

.live-view-drawer__visit-meta {
    font-size: 0.75rem;
    line-height: 1.35;
    color: rgba(255, 255, 255, 0.42);
}

.live-view-drawer__visit-count {
    flex-shrink: 0;
    font-size: 0.85rem;
    font-weight: 600;
    font-variant-numeric: tabular-nums;
    color: rgba(255, 255, 255, 0.72);
    padding-top: 2px;
}

.live-view-drawer__visit-mix-bar {
    display: flex;
    width: 100%;
    height: 8px;
    margin-top: 14px;
    border-radius: 999px;
    overflow: hidden;
    background: rgba(255, 255, 255, 0.06);
}

.live-view-drawer__visit-mix-segment {
    height: 100%;
    min-width: 0;
    transition: width 0.35s ease;
}

.live-view-drawer__visit-mix-segment--accept {
    background: linear-gradient(90deg, rgba(100, 160, 90, 0.9), rgba(140, 200, 120, 0.75));
}

.live-view-drawer__visit-mix-segment--essential {
    background: linear-gradient(90deg, rgba(192, 159, 83, 0.55), rgba(218, 190, 120, 0.85));
}

.live-view-drawer__visit-mix-segment--granular {
    background: linear-gradient(90deg, rgba(90, 140, 165, 0.75), rgba(120, 175, 200, 0.65));
}

.live-view-drawer__granular-head {
    flex-shrink: 0;
    padding: 14px 18px 6px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.04);
}

.live-view-drawer__granular-head .live-view-drawer__summary-label {
    margin-bottom: 6px;
}

.live-view-drawer__granular-sub {
    margin: 0;
    font-size: 0.78rem;
    line-height: 1.4;
    color: rgba(255, 255, 255, 0.4);
}

.live-view-drawer__type-list {
    padding-top: 8px;
}

.live-view-drawer__type-name {
    text-transform: none;
    letter-spacing: 0.02em;
    font-size: 0.8rem;
    font-weight: 600;
    color: rgba(255, 255, 255, 0.82);
}

.live-view-drawer__mini-split {
    display: flex;
    width: 100%;
    height: 5px;
    margin: 8px 0 4px;
    border-radius: 999px;
    overflow: hidden;
    background: rgba(255, 255, 255, 0.06);
}

.live-view-drawer__mini-split-accept {
    height: 100%;
    min-width: 0;
    background: rgba(120, 170, 100, 0.85);
    transition: width 0.35s ease;
}

.live-view-drawer__mini-split-decline {
    height: 100%;
    min-width: 0;
    background: rgba(170, 70, 65, 0.8);
    transition: width 0.35s ease;
}

/* Pagination controls */
.liveView-pagination {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    margin-top: 20px;
    padding-top: 14px;
    border-top: 1px solid rgba(255, 255, 255, 0.07);
}

.liveView-pagination-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    border-radius: 8px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    background: rgba(255, 255, 255, 0.04);
    color: #c6c6c6;
    font-size: 0.9rem;
    font-family: inherit;
    cursor: pointer;
    transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;
}

.liveView-pagination-btn:hover:not(:disabled) {
    background: rgba(192, 159, 83, 0.14);
    border-color: rgba(192, 159, 83, 0.4);
    color: #e8d5a8;
}

.liveView-pagination-btn:disabled {
    opacity: 0.3;
    cursor: not-allowed;
}

.liveView-pagination-info {
    font-size: 0.75rem;
    font-weight: 600;
    color: rgba(255, 255, 255, 0.38);
    letter-spacing: 0.06em;
    font-variant-numeric: tabular-nums;
    min-width: 36px;
    text-align: center;
}

/* Show more / fewer domains */
.liveView-show-more-btn {
    display: block;
    width: 100%;
    margin-top: 6px;
    padding: 6px 10px;
    border-radius: 6px;
    border: 1px solid rgba(255, 255, 255, 0.07);
    background: transparent;
    color: rgba(192, 159, 83, 0.75);
    font-size: 0.72rem;
    font-weight: 600;
    font-family: inherit;
    letter-spacing: 0.04em;
    cursor: pointer;
    text-align: center;
    transition: color 0.15s ease, border-color 0.15s ease, background 0.15s ease;
}

.liveView-show-more-btn:hover {
    color: #e8d5a8;
    border-color: rgba(192, 159, 83, 0.35);
    background: rgba(192, 159, 83, 0.07);
}`, "",{"version":3,"sources":["webpack://./src/Components/LiveView/Style.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,+BAA+B;AACnC;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,aAAa;AACjB;;AAEA,kEAAkE;AAClE;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,SAAS;IACT,iBAAiB;IACjB,2CAA2C;IAC3C,kBAAkB;IAClB,8BAA8B;IAC9B,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,cAAc;IACd,wDAAwD;AAC5D;;AAEA;IACI,oCAAoC;IACpC,sCAAsC;AAC1C;;AAEA;IACI,0CAA0C;IAC1C,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,kCAAkC;AACtC;;AAEA;IACI,WAAW;IACX,WAAW;IACX,eAAe;IACf,oBAAoB;IACpB,qCAAqC;IACrC,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,oBAAoB;IACpB,+EAA+E;IAC/E,4BAA4B;AAChC;;AAEA,qEAAqE;AACrE;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,gCAAgC;IAChC,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,kDAAkD;AACtD;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,8BAA8B;IAC9B,SAAS;IACT,eAAe;IACf,+CAA+C;AACnD;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,gCAAgC;AACpC;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,kCAAkC;IAClC,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,WAAW;IACX,gBAAgB;IAChB,oBAAoB;IACpB,gBAAgB;IAChB,qCAAqC;AACzC;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,4BAA4B;AAChC;;AAEA;IACI,sFAAsF;AAC1F;;AAEA;IACI,uFAAuF;AAC3F;;AAEA;IACI,uFAAuF;AAC3F;;AAEA;IACI,cAAc;IACd,sBAAsB;IACtB,kDAAkD;AACtD;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,+BAA+B;AACnC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,WAAW;IACX,WAAW;IACX,iBAAiB;IACjB,oBAAoB;IACpB,gBAAgB;IAChB,qCAAqC;AACzC;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,qCAAqC;IACrC,4BAA4B;AAChC;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,kCAAkC;IAClC,4BAA4B;AAChC;;AAEA,wBAAwB;AACxB;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,gBAAgB;IAChB,iBAAiB;IACjB,+CAA+C;AACnD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,0CAA0C;IAC1C,qCAAqC;IACrC,cAAc;IACd,iBAAiB;IACjB,oBAAoB;IACpB,eAAe;IACf,4EAA4E;AAChF;;AAEA;IACI,oCAAoC;IACpC,qCAAqC;IACrC,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,gCAAgC;IAChC,sBAAsB;IACtB,kCAAkC;IAClC,eAAe;IACf,kBAAkB;AACtB;;AAEA,8BAA8B;AAC9B;IACI,cAAc;IACd,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,2CAA2C;IAC3C,uBAAuB;IACvB,+BAA+B;IAC/B,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,sBAAsB;IACtB,eAAe;IACf,kBAAkB;IAClB,4EAA4E;AAChF;;AAEA;IACI,cAAc;IACd,sCAAsC;IACtC,oCAAoC;AACxC","sourcesContent":[".liveView-content-title {\n    margin: 10px 10px 0;\n    font-size: 0.6rem;\n    font-weight: 700;\n    letter-spacing: 0.12em;\n    color: rgba(255, 255, 255, 0.3);\n}\n\n.liveView-content-data {\n    margin: 0 10px;\n    padding: 10px 0;\n}\n\n.liveView-content-flex {\n    display: flex;\n    justify-content: space-between;\n}\n\n.liveView-content-data-1-text {\n    margin: 3px 0;\n}\n\n.liveView-content-country {\n    margin-bottom: 5px;\n}\n\n.liveView-content-data-2 {\n    width: 100%;\n}\n\n.liveView-content-data-1-number {\n    font-size: 30px;\n    font-weight: 200;\n    margin-top: 0;\n}\n\n/* Domain rows: clear click target, matches dashboard affordance */\n.liveView-domain-block {\n    margin-bottom: 12px;\n}\n\n.liveView-domain-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    margin: 0;\n    padding: 8px 10px;\n    border: 1px solid rgba(255, 255, 255, 0.08);\n    border-radius: 8px;\n    background: rgba(0, 0, 0, 0.2);\n    cursor: pointer;\n    text-align: left;\n    font: inherit;\n    color: inherit;\n    transition: background 0.2s ease, border-color 0.2s ease;\n}\n\n.liveView-domain-row:hover {\n    background: rgba(192, 159, 83, 0.12);\n    border-color: rgba(192, 159, 83, 0.35);\n}\n\n.liveView-domain-row:focus-visible {\n    outline: 2px solid rgba(192, 159, 83, 0.8);\n    outline-offset: 2px;\n}\n\n.liveView-domain-row__name {\n    word-break: break-all;\n    padding-right: 12px;\n}\n\n.liveView-domain-row__count {\n    flex-shrink: 0;\n    font-variant-numeric: tabular-nums;\n}\n\n.liveView-domain-bar-track {\n    width: 100%;\n    height: 3px;\n    margin-top: 6px;\n    border-radius: 999px;\n    background: rgba(196, 196, 196, 0.35);\n    overflow: hidden;\n}\n\n.liveView-domain-bar-fill {\n    height: 100%;\n    border-radius: 999px;\n    background: linear-gradient(90deg, rgba(192, 159, 83, 0.5), rgb(222, 189, 113));\n    transition: width 0.35s ease;\n}\n\n/* Drawer extras (reuses .world-map-drawer from WorldMap/Style.css) */\n.live-view-drawer__subtitle {\n    margin: 8px 0 0;\n    font-size: 0.78rem;\n    line-height: 1.4;\n    color: rgba(255, 255, 255, 0.45);\n    font-weight: 400;\n}\n\n.live-view-drawer__summary-label {\n    display: block;\n    font-size: 0.62rem;\n    font-weight: 600;\n    letter-spacing: 0.12em;\n    text-transform: uppercase;\n    color: rgba(255, 255, 255, 0.38);\n    margin-bottom: 12px;\n}\n\n.live-view-drawer__visit-patterns {\n    flex-shrink: 0;\n    padding: 14px 18px;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n}\n\n.live-view-drawer__visit-row {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 12px;\n    padding: 10px 0;\n    border-top: 1px solid rgba(255, 255, 255, 0.06);\n}\n\n.live-view-drawer__visit-patterns .live-view-drawer__visit-row:first-of-type {\n    border-top: none;\n    padding-top: 0;\n}\n\n.live-view-drawer__visit-row-main {\n    min-width: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n}\n\n.live-view-drawer__visit-label {\n    font-size: 0.95rem;\n    font-weight: 600;\n    color: rgb(240, 240, 240);\n}\n\n.live-view-drawer__visit-label--accept {\n    color: rgba(170, 220, 155, 0.98);\n}\n\n.live-view-drawer__visit-label--essential {\n    color: rgba(192, 159, 83, 0.95);\n}\n\n.live-view-drawer__visit-label--granular {\n    color: rgba(150, 195, 215, 0.95);\n}\n\n.live-view-drawer__visit-meta {\n    font-size: 0.75rem;\n    line-height: 1.35;\n    color: rgba(255, 255, 255, 0.42);\n}\n\n.live-view-drawer__visit-count {\n    flex-shrink: 0;\n    font-size: 0.85rem;\n    font-weight: 600;\n    font-variant-numeric: tabular-nums;\n    color: rgba(255, 255, 255, 0.72);\n    padding-top: 2px;\n}\n\n.live-view-drawer__visit-mix-bar {\n    display: flex;\n    width: 100%;\n    height: 8px;\n    margin-top: 14px;\n    border-radius: 999px;\n    overflow: hidden;\n    background: rgba(255, 255, 255, 0.06);\n}\n\n.live-view-drawer__visit-mix-segment {\n    height: 100%;\n    min-width: 0;\n    transition: width 0.35s ease;\n}\n\n.live-view-drawer__visit-mix-segment--accept {\n    background: linear-gradient(90deg, rgba(100, 160, 90, 0.9), rgba(140, 200, 120, 0.75));\n}\n\n.live-view-drawer__visit-mix-segment--essential {\n    background: linear-gradient(90deg, rgba(192, 159, 83, 0.55), rgba(218, 190, 120, 0.85));\n}\n\n.live-view-drawer__visit-mix-segment--granular {\n    background: linear-gradient(90deg, rgba(90, 140, 165, 0.75), rgba(120, 175, 200, 0.65));\n}\n\n.live-view-drawer__granular-head {\n    flex-shrink: 0;\n    padding: 14px 18px 6px;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.04);\n}\n\n.live-view-drawer__granular-head .live-view-drawer__summary-label {\n    margin-bottom: 6px;\n}\n\n.live-view-drawer__granular-sub {\n    margin: 0;\n    font-size: 0.78rem;\n    line-height: 1.4;\n    color: rgba(255, 255, 255, 0.4);\n}\n\n.live-view-drawer__type-list {\n    padding-top: 8px;\n}\n\n.live-view-drawer__type-name {\n    text-transform: none;\n    letter-spacing: 0.02em;\n    font-size: 0.8rem;\n    font-weight: 600;\n    color: rgba(255, 255, 255, 0.82);\n}\n\n.live-view-drawer__mini-split {\n    display: flex;\n    width: 100%;\n    height: 5px;\n    margin: 8px 0 4px;\n    border-radius: 999px;\n    overflow: hidden;\n    background: rgba(255, 255, 255, 0.06);\n}\n\n.live-view-drawer__mini-split-accept {\n    height: 100%;\n    min-width: 0;\n    background: rgba(120, 170, 100, 0.85);\n    transition: width 0.35s ease;\n}\n\n.live-view-drawer__mini-split-decline {\n    height: 100%;\n    min-width: 0;\n    background: rgba(170, 70, 65, 0.8);\n    transition: width 0.35s ease;\n}\n\n/* Pagination controls */\n.liveView-pagination {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 12px;\n    margin-top: 20px;\n    padding-top: 14px;\n    border-top: 1px solid rgba(255, 255, 255, 0.07);\n}\n\n.liveView-pagination-btn {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 30px;\n    height: 30px;\n    border-radius: 8px;\n    border: 1px solid rgba(255, 255, 255, 0.1);\n    background: rgba(255, 255, 255, 0.04);\n    color: #c6c6c6;\n    font-size: 0.9rem;\n    font-family: inherit;\n    cursor: pointer;\n    transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;\n}\n\n.liveView-pagination-btn:hover:not(:disabled) {\n    background: rgba(192, 159, 83, 0.14);\n    border-color: rgba(192, 159, 83, 0.4);\n    color: #e8d5a8;\n}\n\n.liveView-pagination-btn:disabled {\n    opacity: 0.3;\n    cursor: not-allowed;\n}\n\n.liveView-pagination-info {\n    font-size: 0.75rem;\n    font-weight: 600;\n    color: rgba(255, 255, 255, 0.38);\n    letter-spacing: 0.06em;\n    font-variant-numeric: tabular-nums;\n    min-width: 36px;\n    text-align: center;\n}\n\n/* Show more / fewer domains */\n.liveView-show-more-btn {\n    display: block;\n    width: 100%;\n    margin-top: 6px;\n    padding: 6px 10px;\n    border-radius: 6px;\n    border: 1px solid rgba(255, 255, 255, 0.07);\n    background: transparent;\n    color: rgba(192, 159, 83, 0.75);\n    font-size: 0.72rem;\n    font-weight: 600;\n    font-family: inherit;\n    letter-spacing: 0.04em;\n    cursor: pointer;\n    text-align: center;\n    transition: color 0.15s ease, border-color 0.15s ease, background 0.15s ease;\n}\n\n.liveView-show-more-btn:hover {\n    color: #e8d5a8;\n    border-color: rgba(192, 159, 83, 0.35);\n    background: rgba(192, 159, 83, 0.07);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
